function obtenerFechaActual(): string {
    const fecha: Date = new Date();

    // Obtiene cada componente de la fecha y hora
    const anio: string = fecha.getFullYear().toString();
    const mes: string = (fecha.getMonth() + 1).toString().padStart(2, '0'); // Los meses van de 0 a 11
    const dia: string = fecha.getDate().toString().padStart(2, '0');
    const horas: string = fecha.getHours().toString().padStart(2, '0');
    const minutos: string = fecha.getMinutes().toString().padStart(2, '0');
    const segundos: string = fecha.getSeconds().toString().padStart(2, '0');

    // Formatea en AAAAMMDD-HHMMSS
    return `${anio}${mes}${dia}-${horas}${minutos}${segundos}`;
}

export default obtenerFechaActual;